module.exports = ".left-side-menu{padding-top:100px}.logo{line-height:100px}\n"